export const yearsRange = (lim = 15) => {
    const spread = [...Array(lim).keys()];
    const currentYear = new Date().getFullYear();
    const yearList = [{ label: '', value: '' }];
    spread.forEach(num => {
        const year = num + currentYear;
        yearList.push({ label: year.toString(), value: year.toString() });
    });
    return yearList;
};

/* TODO: i18n - this field data needs to be translatable */
const theTwelveCurrentMonths = [
    { label: '', value: '' },
    { label: '01 - January', value: '01' },
    { label: '02 - February', value: '02' },
    { label: '03 - March', value: '03' },
    { label: '04 - April', value: '04' },
    { label: '05 - May', value: '05' },
    { label: '06 - June', value: '06' },
    { label: '07 - July', value: '07' },
    { label: '08 - August', value: '08' },
    { label: '09 - September', value: '09' },
    { label: '10 - October', value: '10' },
    { label: '11 - November', value: '11' },
    { label: '12 - December', value: '12' }
];

export const dropDownData = {
    fourDigitYears: yearsRange(),
    monthList: theTwelveCurrentMonths
};

const cardTypeToNameMap = {
    
    'visa': 'Visa',
    'mastercard': 'MasterCard',
    'americanexpress': 'American Express',
    'paypal': 'PayPal',
    'discover': 'Discover'
};

export const getCardDisplayName = cardType => {
        return cardTypeToNameMap[cardType] ? cardTypeToNameMap[cardType]
        : cardType.charAt(0).toUpperCase() + cardType.slice(1);
};
